import {
  EContactsImportType,
  EShareMethodType,
  RefereeType,
} from '@/services/types/referral/referral';

interface IReferralEvent {
  referralType: RefereeType;
  currentEarningsPending: number;
  currentEarningsEarned: number;
}

export interface IReferralCodeShared extends IReferralEvent {
  shareMethod: EShareMethodType;
}

export interface IReferralContactsImported extends IReferralEvent {
  importFrom: EContactsImportType;
}

export enum EReferralEventName {
  REFERRAL_CODE_SHARED = 'Referral Code Shared',
  REFERRAL_CONTACTS_IMPORTED = 'Referral Contacts Imported',
}
